import colors from "../../../Constants/colors";
import theme from "../../../Constants/theme";

export const mainContainer = {
  display: "flex",
  padding: "20px",
  height: "100%",
  flexDirection: "column",
  width: "100%",
  alignItems: "center",
};

export const btnStyles = {
  color: colors.extremeWhite,
  bgcolor: colors.primaryBlue,
  textTransform: "none",
  ":hover": {
    bgcolor: colors.secondaryBlue,
  },
  "&.Mui-disabled": {
    bgcolor: colors.darkGray, // Update this to your defined gray color
    color: colors.extremeWhite,
  },
};
